export class AuthActions {
  static readonly SIGN_IN_SUCCESS = '[AUTH] SIGN_IN_SUCCESS';
  static readonly SIGN_OUT = '[AUTH] SIGN_OUT';
  static readonly SET_SITE = '[AUTH] SET_SITE';
  static readonly RENEW_TOKEN = '[AUTH] RENEW_TOKEN';
  static readonly SET_AUTH = '[AUTH] SET_AUTH';
};
